import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle, AlertTriangle, Bell, X } from 'lucide-react';

const NotificationToast = ({ notification, handleCloseNotification }) => {
  return (
    <AnimatePresence>
      {notification.open && (
        <motion.div
          className={`fixed bottom-6 right-6 max-w-md px-5 py-4 rounded-xl shadow-xl z-50 ${
            notification.severity === 'success' ? 'bg-green-600' :
            notification.severity === 'error' ? 'bg-red-600' :
            notification.severity === 'warning' ? 'bg-amber-600' :
            'bg-blue-600'
          }`}
          initial={{ opacity: 0, y: 50, scale: 0.3 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: 20, scale: 0.5 }}
          transition={{ type: 'spring', damping: 20 }}
        >
          <div className="flex items-start">
            <div className="flex-shrink-0 pt-0.5">
              {notification.severity === 'success' && <CheckCircle className="h-5 w-5 text-white" />}
              {notification.severity === 'error' && <AlertTriangle className="h-5 w-5 text-white" />}
              {notification.severity === 'warning' && <AlertTriangle className="h-5 w-5 text-white" />}
              {notification.severity === 'info' && <Bell className="h-5 w-5 text-white" />}
            </div>
            <div className="ml-3 w-0 flex-1">
              <p className="text-sm font-medium text-white">{notification.message}</p>
            </div>
            <div className="ml-4 flex-shrink-0 flex">
              <button
                className="bg-transparent rounded-md inline-flex text-white/80 hover:text-white"
                onClick={handleCloseNotification}
              >
                <X className="h-5 w-5" />
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default NotificationToast;